import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-delete-ticket',
  templateUrl: './delete-ticket.component.html',
  styleUrls: ['./delete-ticket.component.css']
})
export class DeleteTicketComponent implements OnInit {

  i: any;
  deleteId: any;
  status= "ALL"

  pageNumber: number = 0;
  totalRecords: number = 0;
  recordsPerPage:number = 10;
  tableSize: number = 10;

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  form: any | FormGroup
  modelSubtitle = false
  data:any = []
  fileType:any;
  searchFilter = ''
  newTicketCount= 0

  ngOnInit(): void {
    this.ticketByStatus(); 
  }

  onTableDataChange(event: any) {
    this.pageNumber = event;
    this.getTicketcontroller()
  }
 
  cancelModel(){
    document.getElementById("closeModalButton1")?.click()
  }

  getTicketcontroller(){
    let pageNumber = 0
    if(this.pageNumber == 0){
      pageNumber = this.pageNumber
    }else{
      pageNumber = this.pageNumber-1
    }
    if(this.status != "ALL"){
      this.ticketFilterByStatus(pageNumber,this.recordsPerPage)
    }else{
      this.getAllTicket(pageNumber,this.recordsPerPage)
    }
  }

 

  delTicketController(){
    this.generic_service.delTicketcontroller(this.deleteId).subscribe(
      (res:any)=>{
        console.log(res);
        this.toastr.success("Successfully Deleted");
        this.getTicketcontroller();
        this.cancelModel();
      },err=>{
        console.log(err)
        this.toastr.error(err.errors[0].description)
      }
    )
  }

  del(id:any){
    this.deleteId = id
  }

  ticketByStatus(){
    this.pageNumber = 0
    if(this.status != "ALL"){
      this.ticketFilterByStatus(this.pageNumber,this.recordsPerPage)
    }else{
      this.getAllTicket(this.pageNumber,this.recordsPerPage)
    }
  }

  ticketFilterByStatus(pageNumber:any,recordsPerPage:any){
    this.generic_service.ticketFilterByStatus(pageNumber,recordsPerPage,this.status).subscribe(
      (response:any)=>{
        console.log(response)
        this.totalRecords = response.response.totalRecords
        this.data = response.response.ticketTaskResponseList
      },
      (error:any)=>{
        console.log(error)
      }
    )
  }

  getAllTicket(pageNumber:any,recordsPerPage:any){
    this.generic_service.getcontroller(pageNumber,recordsPerPage).subscribe(
      (response:any)=>{
        this.totalRecords = response.response.totalRecords
        this.data = response.response.ticketList
        console.log(response)
      }
    )
  }

 
}